import { useState, useEffect } from "react";
import { Flex, Heading, Text } from "@radix-ui/themes";

export const BrowserInfo = () => {
  const [dimensions, setDimensions] = useState({
    width: 0,
    height: 0,
    ppi: 0,
    dpr: 0,
  });

  const updateDimensions = () => {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const ppi =
      Math.sqrt(
        Math.pow(window.screen.width, 2) + Math.pow(window.screen.height, 2)
      ) /
      Math.sqrt(
        Math.pow(window.screen.width / window.devicePixelRatio, 2) +
        Math.pow(window.screen.height / window.devicePixelRatio, 2)
      );
    const dpr = window.devicePixelRatio;
    setDimensions({ width, height, ppi, dpr });
  };

  useEffect(() => {
    updateDimensions();
    window.addEventListener("resize", updateDimensions);

    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  return (
    <Flex
      className="browser-info"
      align={"center"}
      justify={"center"}
      direction={"column"}
      width={"fit-content"}
      height={"100vh"}
      m={"auto"}
    >
      <Heading as="h4">Screen resolution info</Heading>
      <Text color="gray" size={"7"}>Width: {dimensions.width}px</Text>
      <Text color="gray" size={"7"}>Height: {dimensions.height}px</Text>
      <Text color="gray" size={"7"}>PPI: {dimensions.ppi.toFixed(2)}</Text>
      <Text color="gray" size={"7"}>Device Pixel Ratio: {dimensions.dpr}</Text>
    </Flex>
  );
};
